/*@flow*/
/** @jsx jsx */
import { jsx } from '@emotion/core';

function MemberFormErrorOutput({ errors }: { errors: ?(string[]) }) {
  if (!errors) return null;
  return (
    <div data-testid="MemberFormErrorOutput" className="text-danger">
      {errors.map((v, i) => (
        <div key={i}>{v}</div>
      ))}
    </div>
  );
}

export default (MemberFormErrorOutput: any);
